<template>
    <cadastro-simples-list
        endpoint="grupo-conteudo"
        rota-base="/admin/grupo-conteudo"
        titulo="GRUPOS DE CONTEÚDO"
        titulo-singular="Grupo de Conteúdo"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
